import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));

declare global {
  interface Date {
    toShortDateTimeString(): string;
    toShortDateString(): string;
    addDays(n: number): Date;
  }
}

Date.prototype.toShortDateTimeString = function (): string {
  let dd = ('0' + (this.getDate().toString())).substr(-2);
  let mm = ('0' + ((this.getMonth() + 1).toString())).substr(-2);
  let yy = (this.getFullYear().toString()).substr(-2);
  let hh = ('0' + (this.getHours().toString())).substr(-2);
  let mins = ('0' + (this.getMinutes().toString())).substr(-2);
  return dd + '/' + mm + '/' + yy + ' ' + hh + ':' + mins;
}

Date.prototype.toShortDateString = function (): string {
  let dd = ('0' + (this.getDate().toString())).substr(-2);
  let mm = ('0' + ((this.getMonth() + 1).toString())).substr(-2);
  let yyyy = (this.getFullYear().toString());
  return yyyy + "-" + mm + "-" + dd
}

Date.prototype.addDays = function (days) {
  var date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
}
